import { render, staticRenderFns } from "./NewInbookForm.vue?vue&type=template&id=2a3ea3bb"
import script from "./NewInbookForm.vue?vue&type=script&lang=js"
export * from "./NewInbookForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports